import Box from '~/common/components/Box';
import { buildBoltIncidentUrl } from '~/common/components/Nav/Rail/constants';
import useGetLoanSummary from '~/common/hooks/useGetLoanSummary';
import Button from '~/common/mui/Buttons/MUIButton/MUIButton';
import MUIDialog from '~/common/mui/MUIDialog/MUIDialog';

import { useModalState } from '../modalStore';

export function BoltIncidentModal() {
  const { isOpen, onClose } = useModalState('boltIncidentInterceptor');
  const { loanNumber } = useGetLoanSummary().data?.loanInfo || {};

  if (!isOpen) {
    return null;
  }

  return (
    <MUIDialog
      open={isOpen}
      onClose={onClose}
      title="Before You Submit a BOLT Incident"
      dialogPosition="center"
      hideBackdrop={false}
      sx={{
        width: '40rem',
        margin: 'auto',
      }}
      actions={
        <Box
          sx={{
            padding: '1rem',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '1rem',
          }}
        >
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            component={'a'}
            href={buildBoltIncidentUrl({
              loanNumber,
            })}
            onClick={onClose}
            // @ts-expect-error anchor tag props
            rel="noopener noreferrer"
            target="_blank"
          >
            Cache Cleared, Proceed
          </Button>
        </Box>
      }
    >
      System issues could be resolved by clearing cache and cookies. Before
      submitting a ticket, try using this keyboard shortcut: CTRL + SHIFT + DEL.
      When the dialog opens, select All time for the time range, verify all
      boxes are checked, and select Delete from this device. Then restart your
      browser and try again.
    </MUIDialog>
  );
}
